import { Box, FormHelperText, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { ITheme } from "../../utils/theme";
import CharacterCount from "../CharacterCount";

interface FormattedPhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  required?: boolean;
  placeholder?: string;
  error?: JSX.Element | string;
  maxLength?: number;
}

export const FormattedPhoneInput: React.FC<FormattedPhoneInputProps> = ({
  value,
  onChange,
  label,
  required = false,
  placeholder,
  error,
  maxLength
}) => {
  const formatPhone = (input: string) => {
    const cleaned = input.replace(/\D+/g, "").slice(0, 10);
    return cleaned.length === 10
      ? `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
      : cleaned;
  };

  const handleInputChange = (input: string) => {
    const cleaned = input.replace(/\D+/g, "").slice(0, 10);
    const formatted = formatPhone(cleaned);
    onChange(formatted);
  };

  useEffect(() => {
    if (value && value.replace(/\D/g, "").length === 10) {
      const formatted = formatPhone(value);
      if (formatted !== value) {
        onChange(formatted);
      }
    }
  }, [value, onChange]);

  return (
    <Box sx={{ mb: maxLength ? '-16px' : 0 }}>
      <Typography variant="form-label" sx={{ fontWeight: "normal" }}>
        {label}
        {required && (
          <Typography
            component="span"
            sx={{ color: (theme: ITheme) => theme.palette.red.A700, ml: 0.5 }}
          >
            *
          </Typography>
        )}
      </Typography>
      <TextField
        error={!!error}
        fullWidth
        value={value}
        onChange={(e) => handleInputChange(e.target.value)}
        required={required}
        placeholder={placeholder || "(xxx) xxx-xxxx"}
        inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 14 }}
      />
      {maxLength && !error && <CharacterCount currentLength={value.replace(/\D/g, "").length} maxLength={maxLength} />}
      {error && <FormHelperText
        component={'div'}
        error={!!error}
      >
        {error}
      </FormHelperText>}
    </Box>
  );
};
